import React, { Component } from 'react';

class ChartFullScreenWrapper extends Component {

  state = {
    isZoomed: false,
    isScaling: false,
  }

  setIsZoomed = isZoomed => {
    this.setState({ isScaling: true });

    setTimeout(() => {
      this.setState({ isZoomed: isZoomed, isScaling: false });
    }, 250);
  }

  onOverlayClicked = event => {
    event.stopPropagation();
    this.setIsZoomed(false);
  }

  onZoomClicked = event => {
      event.stopPropagation();
      this.setIsZoomed(!this.state.isZoomed);
  }

  renderZoomButton = () => {
    const { dataTarget, reactModal } = this.props;
    const { isZoomed } = this.state;

    if (reactModal === true) {
      return (
        <a href="#" onClick={this.onZoomClicked} className="big-edit zoom-in-chart">
          <i className="material-icons">{isZoomed ? 'clear' : 'zoom_out_map'}</i>
        </a>);
    } else {
      return (
        <a href="#" data-toggle="modal" data-target={dataTarget || '#fullscreenModal'} className="big-edit zoom-in-chart modal-action">
          <i className="material-icons">zoom_out_map</i>
        </a>);
    }
  }

  render = () => {
    const { children, style } = this.props;
    const { isZoomed, isScaling } = this.state;

    let overlayStyle = { display: 'none' };
    const classNames = ['chart-wrapper'];
    
    if (isScaling) {
      classNames.push('scale');
    }
    if (isZoomed) {
      classNames.push('zoomed-chart');
      overlayStyle = {    
        position: 'fixed',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        background: '#222',
        zIndex: 1050,
        opacity: 0.5,
        overflow: 'hidden',
      }
    }

    return (
      <div>
        <div style={overlayStyle} onClick={this.onOverlayClicked}/>
        <div className={classNames.join(' ')} style={style}>
          {this.renderZoomButton()}
          {children}
        </div>
      </div>);
  };
}

export default ChartFullScreenWrapper;



// WEBPACK FOOTER //
// ./App/components/modules/chart-fullscreen-wrapper/chart-fullscreen-wrapper.js